import { useCallback, useEffect, useState } from 'react';
import { listViolationEvents } from '../services/violations';
import { getCamera } from '../services/cameras';
import {
  FALLBACK_KEYS,
  isStandalonePwa,
  readStored,
  shouldShowViolationBanner,
  writeStored,
} from '../utils/foregroundFallback';

/**
 * Слушает visibilitychange и при возврате установленной PWA из background
 * запрашивает последние доступные события. Полноценным каналом доставки это не
 * является — только страховка для iPhone.
 */
export const useForegroundViolationBanner = () => {
  const [event, setEvent] = useState(null);

  const dismiss = useCallback(() => {
    if (event?.id) writeStored(FALLBACK_KEYS.LAST_HANDLED_EVENT, event.id);
    setEvent(null);
  }, [event]);

  useEffect(() => {
    if (!isStandalonePwa()) return undefined;

    const onVisibilityChange = () => {
      if (document.hidden) {
        writeStored(FALLBACK_KEYS.LAST_BACKGROUND_AT, new Date().toISOString());
        return;
      }

      listViolationEvents({ limit: 1, offset: 0 })
        .then((response) => {
          const latest = response.items[0] || null;
          const candidate = {
            event: latest,
            lastHandledEventId: readStored(FALLBACK_KEYS.LAST_HANDLED_EVENT),
            lastBackgroundAt: readStored(FALLBACK_KEYS.LAST_BACKGROUND_AT),
          };
          if (shouldShowViolationBanner(candidate)) {
            // Дотягиваем имя камеры, которого нет в DTO listViolationEvents
            if (latest?.camera_id) {
              getCamera(latest.camera_id)
                .then((cam) => {
                  latest.camera_name = cam.name;
                  setEvent(latest);
                })
                .catch(() => {
                  // Ошибку глушим: баннер обязан показаться и без имени
                  setEvent(latest);
                });
            } else {
              setEvent(latest);
            }
          }
        })
        .catch(() => { /* фоновая страховка: молча ничего не показываем */ });
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, []);

  return { event, dismiss };
};

export default useForegroundViolationBanner;
